(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("spherical-panorama", [], factory);
	else if(typeof exports === 'object')
		exports["spherical-panorama"] = factory();
	else
		root["spherical-panorama"] = factory();
})(self, function() {
return 